export var isElementInParentBlock = function isElementInParentBlock(el, parent) {
  var viewPercent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var rectInner = el.getBoundingClientRect();
  var rectParent = parent.getBoundingClientRect();
  var vertTopInView = rectInner.top + rectInner.height * viewPercent <= rectParent.height + rectParent.top;
  var horLeftInView = rectInner.left + rectInner.width * viewPercent <= rectParent.width + rectParent.left;
  return vertTopInView && horLeftInView;
};